import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { imgUrl } from 'src/actions/types';
import { Link } from 'react-router-dom'; 
import {
  setPatientProfile,
  getOnePatientProfile,
  updatePatientProfile,
} from '../../actions/patientProfileActions';
import MessageModal from '../Pages/MessageModel';
import { getAllUsers, updateUser } from '../../actions/loginAction';

const ProfileSettings = (props) => {
  const dispatch = useDispatch();
  const patientProfile = useSelector((state) => state.patientProfile.profile);
  const hospitalID = localStorage.getItem('hospitalCode') || '';

  const [formData, setFormData] = useState({
    PatientID: hospitalID,
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    gender: '', // Added gender field
    bloodGrp: '',
    email: '',
    phoneNumber: '',
    address: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
    uploadPhoto: null,
  });

  const [previewImage, setPreviewImage] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const [modalVariant, setModalVariant] = useState('info');
  const DEFAULT_PATIENT_IMAGE = 'assets/img/patient_defaultImage .jpg';

  const urlToFile = async (url, filename, mimeType) => {
    try {
      const res = await fetch(url);
      const buf = await res.arrayBuffer();
      return new File([buf], filename, { type: mimeType });
    } catch (error) {
      console.error("Image conversion error:", error);
      return null;
    }
  };
  // Fetch existing profile
  useEffect(() => {
    if (hospitalID) dispatch(getOnePatientProfile(hospitalID));
  }, [dispatch, hospitalID]);

  // Set form data from existing profile (if any)
// useEffect(() => {
//   if (patientProfile && patientProfile.PatientID) {
//     setIsEditMode(true);
//     const { uploadPhoto, ...rest } = patientProfile;
//     setFormData((prev) => ({ ...prev, ...rest, uploadPhoto: uploadPhoto || null }));
    
//     if (uploadPhoto) {
//       setPreviewImage(`${imgUrl}${uploadPhoto}`);
//     } else {
//       setPreviewImage(DEFAULT_PATIENT_IMAGE);
//     }
//   } else {
//     setIsEditMode(false);
//     setPreviewImage(DEFAULT_PATIENT_IMAGE);
//   }
// }, [patientProfile]);
// Is useEffect ko replace karein
useEffect(() => {
  if (patientProfile && patientProfile.PatientID) {
    setIsEditMode(true);
    // Destructure karein taaki hum image ko handle kar sakein
    const { uploadPhoto, ...rest } = patientProfile;
    
    setFormData((prev) => ({ 
      ...prev, 
      ...rest, 
      uploadPhoto: uploadPhoto || null // String path store karein
    }));
    
    // Preview state update karne ki zaroorat nahi hai agar hum JSX mein direct logic likhenge
  } else {
    setIsEditMode(false);
    setFormData((prev) => ({ ...prev, uploadPhoto: null }));
  }
}, [patientProfile]);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  
  const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setFormData((prev) => ({ ...prev, uploadPhoto: file }));
    setPreviewImage(URL.createObjectURL(file));
  }
};

  const showModal = (title, message, variant = 'info') => {
    setModalTitle(title);
    setModalMessage(message);
    setModalVariant(variant);
    setModalShow(true);
  };

  const handleCreateProfile = async () => {
  setLoading(true);
  const payload = new FormData();
  payload.append('PatientID', hospitalID);

  // Logic to handle images and text fields
  for (const [key, value] of Object.entries(formData)) {
    if (key === 'uploadPhoto') {
      if (value instanceof File) {
        // User uploaded a new file
        payload.append("uploadPhoto", value);
      } else {
        // No file uploaded, send the default image as a file
        const defaultFile = await urlToFile(DEFAULT_PATIENT_IMAGE, "default_patient.jpg", "image/jpeg");
        if (defaultFile) payload.append("uploadPhoto", defaultFile);
      }
    } else if (key !== 'PatientID' && value) {
      payload.append(key, value);
    }
  }

  const userData = {
    hospitalID: hospitalID,
    first_name: formData.firstName || '',
    last_name: formData.lastName || '',
    email: formData.email || '',
    mobile: formData.phoneNumber || '',
    role: 'Patient',
  };

  try {
    await dispatch(setPatientProfile(payload));
    await dispatch(updateUser(userData));
    await dispatch(getOnePatientProfile(hospitalID));
    showModal('Success', 'Profile created and user data updated successfully.', 'success');
  } catch (err) {
    showModal('Error', 'Failed to create profile or update user.', 'danger');
  } finally {
    setLoading(false);
  }
};
  
 const handleUpdateProfile = async () => {
  setLoading(true);
  const payload = new FormData();

   for (const [key, value] of Object.entries(formData)) {
    if (key === 'uploadPhoto') {
      if (value instanceof File) {
        // Nayi select ki hui file
        payload.append("uploadPhoto", value);
      } else if (typeof value === "string" && value !== "") {
        // Purani image ka path (Backend ko batane ke liye ki image delete nahi karni)
        payload.append("uploadPhoto", value);
      } else if (value === null || value === "") {
        // Remove button click hua hai, default upload karein
        const defaultFile = await urlToFile(DEFAULT_PATIENT_IMAGE, "default_patient.jpg", "image/jpeg");
        if (defaultFile) payload.append("uploadPhoto", defaultFile);
      }
    } else if (value) {
      payload.append(key, value);
    }
  }

  const userData = {
    hospitalID: formData.PatientID,
    first_name: formData.firstName || '',
    last_name: formData.lastName || '',
    email: formData.email || '',
    mobile: formData.phoneNumber || '',
    role: 'Patient',
  };

  try {
    await dispatch(updateUser(userData));
    await dispatch(updatePatientProfile(payload));
    await dispatch(getOnePatientProfile(hospitalID));
    showModal('Success', 'Profile updated successfully.', 'success');
  } catch (err) {
    showModal('Error', 'Failed to update profile.', 'danger');
  } finally {
    setLoading(false);
  }
};

  const handleSubmit = (e) => {
    e.preventDefault();
    isEditMode ? handleUpdateProfile() : handleCreateProfile();
  };
  const handleRemovePhoto = () => {
  setFormData((prev) => ({ ...prev, uploadPhoto: null }));
  setPreviewImage(DEFAULT_PATIENT_IMAGE);
};
 
  const pageTitle = "Profile Settings | Medisevas";
  const pageDescription = "Manage your personal profile and account settings on Medisevas. Keep your information up-to-date for a seamless healthcare experience.";
  
  return (
    <div>
       <div className="page-header filter-bar rounded ">
                <div className="row align-items-center">
                    <div className="col">
                        <h4 className="page-title">Profile-Settings</h4>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/doctor/dashboard">Patient Dashboard</Link></li>
                            <li className="breadcrumb-item active">Profile-Settings</li>
                        </ul>
                    </div>
                </div>
      </div>
 
    <div className="row">
      
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
      </Helmet>
      <div className="col-md-12">
        <div className="card ">
        
          <div className="card-body ">
            <div className='px-3 '>
         
            <form onSubmit={handleSubmit}>
              <div className="row form-row">
                {/* Avatar Upload */}
                {/* <div className="col-12 col-md-12">
                  <div className="form-group">
                    <div className="change-avatar">
                      <div className="profile-img">
  <img
    src={previewImage || DEFAULT_PATIENT_IMAGE}
    alt="User"
    style={{
      width: 100,
      height: 100,
      objectFit: 'cover',
      borderRadius: '50%',
    }}
    onError={(e) => { e.target.src = DEFAULT_PATIENT_IMAGE; }}
  />
</div>
<div className="upload-img">
  <div className="change-photo-btn" style={{backgroundColor: '#0084d9' }}>
    <span>
      <i className="fa fa-upload" /> Upload Photo
    </span>
    <input type="file" className="upload" onChange={handleFileChange} />
  </div>

  {previewImage !== DEFAULT_PATIENT_IMAGE && (
    <button
      type="button"
      className="clear-button"
      onClick={handleRemovePhoto}
      
    >
      <i className="fa fa-trash mr-1"></i> Remove Photo
    </button>
  )}

  <small className="form-text text-muted">
    Allowed JPG, GIF or PNG. Max size of 2MB
  </small>
</div>
                    </div>
                  </div>
                </div> */}
               <div className="col-12 col-md-12">
  <div className="form-group">
    <div className="change-avatar">
      {/* Profile Image Preview */}
      <div className="profile-img">
        <img
          src={
            formData.uploadPhoto instanceof File
              ? URL.createObjectURL(formData.uploadPhoto) // Nayi image select hone par
              : formData.uploadPhoto && typeof formData.uploadPhoto === "string"
              ? (formData.uploadPhoto.startsWith("blob:") ? formData.uploadPhoto : `${imgUrl}${formData.uploadPhoto}`) // Existing database image
              : DEFAULT_PATIENT_IMAGE // Kuch nahi hai toh default placeholder
          }
          alt="User"
          style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "50%" }}
          onError={(e) => { e.target.src = DEFAULT_PATIENT_IMAGE; }}
        />
      </div>

      <div className="upload-img">
        <div>
          <button
            type="button"
            className="btn btn-info rounded-pill mb-2"
            onClick={() => document.getElementById("patient-photo").click()}
             style={{ fontSize: '12px', padding: '5px 15px' }}
          >
            Upload Photo
          </button>
          <input
            id="patient-photo"
            type="file"
            className="upload"
            accept="image/*"
            onChange={handleFileChange}
            hidden
           
          />
        </div>

        {/* REMOVE BUTTON LOGIC */}
        {formData.uploadPhoto && formData.uploadPhoto !== "" && (
          <button
            type="button"
            className="btn btn-danger  rounded-pill d-block"
            onClick={handleRemovePhoto}
            style={{ fontSize: '12px', padding: '5px 15px' }}
          >
           Remove Photo
          </button>
        )}

        <small className="form-text text-muted">
          Allowed JPG, GIF or PNG. Max size of 2MB
        </small>
      </div>
    </div>
  </div>
</div>
                {/* Text Inputs */}
                {[
                  ['First Name', 'firstName'],
                  ['Last Name', 'lastName'],
                  ['Date of Birth', 'dateOfBirth'],
                  ['Email ID', 'email'],
                  ['Mobile', 'phoneNumber'],
                  ['Address', 'address'],
                  ['City', 'city'],
                  ['State', 'state'],
                  ['Zip Code', 'postalCode'],
                  ['Country', 'country'],
                ].map(([label, name]) => (
                  <div className="col-12 col-md-6" key={name}>
                    <div className="form-group">
                      <label>{label}</label>
                      <input
                        type={name === 'dateOfBirth' ? 'date' : 'text'}
                        name={name}
                        className="form-control"
                        value={formData[name] || ''}
                        onChange={handleChange}
                        required={['firstName', 'lastName'].includes(name)}
                      />
                    </div>
                  </div>
                ))}

                {/* Gender Dropdown */}
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label>Gender</label>
                    <select
                      name="gender"
                      className="form-control select"
                      value={formData.gender || ''}
                      onChange={handleChange}
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>

                {/* Blood Group Dropdown */}
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label>Blood Group</label>
                    <select
                      name="bloodGrp"
                      className="form-control select"
                      value={formData.bloodGrp || ''}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      {['A-', 'A+', 'B-', 'B+', 'AB-', 'AB+', 'O-', 'O+'].map((group) => (
                        <option key={group} value={group}>
                          {group}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Submit */}
              <div className="submit-section mt-3">
                <button type="submit" className="update-button" disabled={loading}>
                  {loading
                    ? 'Processing...'
                    : isEditMode
                    ? 'Update Profile'
                    : 'Save Profile'}
                </button>
              </div>
            </form>

            {/* Message Modal */}
            <MessageModal
              show={modalShow}
              onClose={() => setModalShow(false)}
              title={modalTitle}
              message={modalMessage}
              variant={modalVariant}
            />
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

const mapStateToProps = (state) => ({
  userList: state.loginReducer.userList,
});

export default connect(mapStateToProps, {
  getAllUsers,
  updateUser,
})(ProfileSettings);